// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-img-report-card {
    .img-title-description-report-card {
        display: flex !important;
        height: auto;

        .description {
            display: none;
        }
    }

    .img-lightbox-report-card {
        display: none;
        left: 0;
        right: auto;
        gap: 5px;
        padding: 0 5px;
        opacity: 0;
        width: fit-content;
        background-color: transparent;

        & md-icon {
            font-size: 24px;
        }

        & > * {
            display: flex;
            --md-icon-custom-size: 30px;
            width: var(--md-icon-custom-size);
            height: var(--md-icon-custom-size);
            font-size: var(--md-icon-custom-size);
            padding: 3px;
            border-radius: var(--radius-small);
            background-color: var(--surface-variant-dark-transparency);
        }
    }

    .img-icons-report-add-cart {
        display: flex;
        top: 30px;
        max-width: 50%;
        flex-direction: column;
        width: fit-content;
        background-color: transparent;
        opacity: 0;
        padding: 0;
        gap: 5px;

        & > * {
            border-radius: var(--radius-small);
            background-color: var(--surface-variant-dark-transparency);
        }

        & > md-icon {
            font-size: 24px;
        }
    }

    [data-report-pdf],
    [data-report-pdf-icon] {
        display: none;
        opacity: 0;
    }

    .type-report {
        display: none !important;
        position: absolute;
        left: 0;
        top: 0;
        width: fit-content;
        height: 25px;
        color: var(--on-primary);
        border-radius: var(--radius-medium);
        max-width: 50%;
        margin-inline-start: 3px;

        & p {
            margin-block: 0.25rem;
            margin-inline: 1rem;
            height: 100%;
            max-height: 16px;
            background-color: transparent;
            color: #fff;
        }
    }

    &:hover {
        .img-icons-report-number-photos {
            background-color: var(--surface-variant-transparency);
            transition: background-color 0.5s ease-in-out;
        }

        .img-title-description-report-card {
            max-height: 50%;
            transition: height 3s ease-in;

            .description {
                display: -webkit-box;
            }
        }

        .img-lightbox-report-card,
        .img-icons-report-add-cart {
            transition: opacity 0.4s ease-in-out;
            opacity: 1;
        }

        .type-report {
            background-color: var(--surface-variant-transparency);
            color: var(--on-surface-variant-transparency);
            transition: background-color 0.5s ease-in-out color 0.5s ease-in-out;
        }

        .img-icons-report-add-cart {
            display: flex;
        }
    }

    [data-zoom-modal-icon] {
        display: none;
    }

    .options-download-modal {
        flex-direction: column;
        align-items: center;
    }

    .overlay {
        position: absolute;
    }
}
`, "",{"version":3,"sources":["webpack://./../components/src/layouts/ResultsGridLayout/components/ReportCardComponent/ReportCardComponent.css"],"names":[],"mappings":"AAAA;IACI;QACI,wBAAwB;QACxB,YAAY;;QAEZ;YACI,aAAa;QACjB;IACJ;;IAEA;QACI,aAAa;QACb,OAAO;QACP,WAAW;QACX,QAAQ;QACR,cAAc;QACd,UAAU;QACV,kBAAkB;QAClB,6BAA6B;;QAE7B;YACI,eAAe;QACnB;;QAEA;YACI,aAAa;YACb,2BAA2B;YAC3B,iCAAiC;YACjC,kCAAkC;YAClC,qCAAqC;YACrC,YAAY;YACZ,kCAAkC;YAClC,0DAA0D;QAC9D;IACJ;;IAEA;QACI,aAAa;QACb,SAAS;QACT,cAAc;QACd,sBAAsB;QACtB,kBAAkB;QAClB,6BAA6B;QAC7B,UAAU;QACV,UAAU;QACV,QAAQ;;QAER;YACI,kCAAkC;YAClC,0DAA0D;QAC9D;;QAEA;YACI,eAAe;QACnB;IACJ;;IAEA;;QAEI,aAAa;QACb,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,kBAAkB;QAClB,YAAY;QACZ,wBAAwB;QACxB,mCAAmC;QACnC,cAAc;QACd,wBAAwB;;QAExB;YACI,qBAAqB;YACrB,mBAAmB;YACnB,YAAY;YACZ,gBAAgB;YAChB,6BAA6B;YAC7B,WAAW;QACf;IACJ;;IAEA;QACI;YACI,qDAAqD;YACrD,6CAA6C;QACjD;;QAEA;YACI,eAAe;YACf,6BAA6B;;YAE7B;gBACI,oBAAoB;YACxB;QACJ;;QAEA;;YAEI,oCAAoC;YACpC,UAAU;QACd;;QAEA;YACI,qDAAqD;YACrD,6CAA6C;YAC7C,oEAAoE;QACxE;;QAEA;YACI,aAAa;QACjB;IACJ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".container-img-report-card {\n    .img-title-description-report-card {\n        display: flex !important;\n        height: auto;\n\n        .description {\n            display: none;\n        }\n    }\n\n    .img-lightbox-report-card {\n        display: none;\n        left: 0;\n        right: auto;\n        gap: 5px;\n        padding: 0 5px;\n        opacity: 0;\n        width: fit-content;\n        background-color: transparent;\n\n        & md-icon {\n            font-size: 24px;\n        }\n\n        & > * {\n            display: flex;\n            --md-icon-custom-size: 30px;\n            width: var(--md-icon-custom-size);\n            height: var(--md-icon-custom-size);\n            font-size: var(--md-icon-custom-size);\n            padding: 3px;\n            border-radius: var(--radius-small);\n            background-color: var(--surface-variant-dark-transparency);\n        }\n    }\n\n    .img-icons-report-add-cart {\n        display: flex;\n        top: 30px;\n        max-width: 50%;\n        flex-direction: column;\n        width: fit-content;\n        background-color: transparent;\n        opacity: 0;\n        padding: 0;\n        gap: 5px;\n\n        & > * {\n            border-radius: var(--radius-small);\n            background-color: var(--surface-variant-dark-transparency);\n        }\n\n        & > md-icon {\n            font-size: 24px;\n        }\n    }\n\n    [data-report-pdf],\n    [data-report-pdf-icon] {\n        display: none;\n        opacity: 0;\n    }\n\n    .type-report {\n        display: none !important;\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: fit-content;\n        height: 25px;\n        color: var(--on-primary);\n        border-radius: var(--radius-medium);\n        max-width: 50%;\n        margin-inline-start: 3px;\n\n        & p {\n            margin-block: 0.25rem;\n            margin-inline: 1rem;\n            height: 100%;\n            max-height: 16px;\n            background-color: transparent;\n            color: #fff;\n        }\n    }\n\n    &:hover {\n        .img-icons-report-number-photos {\n            background-color: var(--surface-variant-transparency);\n            transition: background-color 0.5s ease-in-out;\n        }\n\n        .img-title-description-report-card {\n            max-height: 50%;\n            transition: height 3s ease-in;\n\n            .description {\n                display: -webkit-box;\n            }\n        }\n\n        .img-lightbox-report-card,\n        .img-icons-report-add-cart {\n            transition: opacity 0.4s ease-in-out;\n            opacity: 1;\n        }\n\n        .type-report {\n            background-color: var(--surface-variant-transparency);\n            color: var(--on-surface-variant-transparency);\n            transition: background-color 0.5s ease-in-out color 0.5s ease-in-out;\n        }\n\n        .img-icons-report-add-cart {\n            display: flex;\n        }\n    }\n\n    [data-zoom-modal-icon] {\n        display: none;\n    }\n\n    .options-download-modal {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .overlay {\n        position: absolute;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
